/** Baixa um objeto como arquivo .json formatado (2 espaços). */
export function downloadJson(filename: string, data: unknown): void {
  const blob = new Blob([`${JSON.stringify(data, null, 2)}\n`], {
    type: 'application/json;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Safari precisa do tick antes de liberar a URL.
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
